var _defs, _line, _polyline, _polyline2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #89397d;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26,
    y1: 26.24,
    x2: 26,
    y2: 17.95
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "32.75 26.24 32.75 21.59 34.59 19.68"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "19.25 26.24 19.25 21.59 17.23 19.49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.07,16.03c0-1.04.81-1.88,1.81-1.88s1.81.84,1.81,1.88-.81,1.88-1.81,1.88-1.81-.84-1.81-1.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.12,14.15c1,0,1.81.84,1.81,1.88s-.81,1.88-1.81,1.88-1.81-.84-1.81-1.88.81-1.88,1.81-1.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,11.1c1,0,1.81.84,1.81,1.88s-.81,1.88-1.81,1.88-1.81-.84-1.81-1.88.81-1.88,1.81-1.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.86,1h3.2c1.09,0,1.97.91,1.97,2.04v26.53H5.97V3.04c0-1.13.88-2.04,1.97-2.04h33.11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,30.57h50v.75c0,1.48-1.2,2.68-2.68,2.68H3.68c-1.48,0-2.68-1.2-2.68-2.68v-.75h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPurple);
export default __webpack_public_path__ + "static/media/dashboard-purple.78cec6ca607844a6fe942c6b05ca1227.svg";
export { ForwardRef as ReactComponent };